import request from '@/util/request';

export const getList = (current, size, params) => {
  return request({
    url: '/api/fee/feeitemsetpreferent/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getFeeItemsetList = (propertyId, validFlag) => {
  return request({
    url: '/api/fee/itemset/property_itemset_selections',
    method: 'get',
    params: {
      propertyId,
      validFlag,
    },
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/fee/feeitemsetpreferent/detail',
    method: 'get',
    params: {
      id,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: '/api/fee/feeitemsetpreferent/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: '/api/fee/feeitemsetpreferent/submit',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/fee/feeitemsetpreferent/submit',
    method: 'post',
    data: row,
  });
};
